export enum JobEditStep {
  details = "details",
  career = "career",
  final = "final",
}
